module.exports = __webpack_public_path__ + "static/media/back.dc8c47fa.svg";